export default "__VITE_ASSET__BZQZKnjj__"